<template>
	<div class="cp-news-article-navigation">
		<div class="cp-news-article-navigation-outer-container">
			<div class="cp-news-article-navigation-previous">
				<a class="cp-news-article-navigation-container" :href="prevArticle.url">
					
					<h3 class="cp-news-article-navigation-title previous"><i class="bi bi-arrow-left"></i> Previous</h3>
					<h5 class="cp-news-article-navigation-subtitle">
						{{ prevArticle.title }}
					</h5>
				</a>
			</div>

			<div class="cp-news-article-navigation-next">
				<a class="cp-news-article-navigation-container" :href="nextArticle.url">
					
					<h3 class="cp-news-article-navigation-title next">Next <i class="bi bi-arrow-right"></i> </h3>
					<h5 class="cp-news-article-navigation-subtitle">
						{{ nextArticle.title }}
					</h5>
				</a>
			</div>
		</div>
	</div>
</template>
<script>
import axios from "axios";
export default {
	props: {
		articleId: String,
	},
	components: {},
	data() {
		return {
			newsNav: [],
			nextArticle: [],
			prevArticle: [],
			paginate: ["sortedItems"],
			formattedDate: null,
		};
	},

	created() {
		axios.get(`/api/NewsApi/GetById/${this.articleId}`).then((response) => {
			this.newsNav = response.data;
			this.nextArticle = this.newsNav.next;
			this.prevArticle = this.newsNav.previous;
		});
	},
};
</script>
